import { z } from "zod";
import { CustomFieldDataType } from "@/enums/CustomFieldDataType";
import { CustomFieldScope } from "@/enums/CustomFieldScope";

export const CustomFieldSchema = z.object({
    id: z.number(),
    label: z.string(),
    scope: z.nativeEnum(CustomFieldScope),
    dataType: z.nativeEnum(CustomFieldDataType),
    active: z.boolean(),
    width: z.number().nullable(),
    listValues: z.array(z.string()),
});

export const CustomFieldListSchema = z.array(CustomFieldSchema);

export type CustomField = z.infer<typeof CustomFieldSchema>;